import React from 'react'
import { useNavigate } from 'react-router'
import Jumbotron from '../pure/jumbotron'
import industriaIcon from "../../icons/industryIcon.png"
import focoIcon from "../../icons/bombillaIcon.png"
import arbolIcon from "../../icons/arbolIcon.png"
import arboladoIcon from "../../images/proccess1.png"
import empresaIcon from "../../images/proccess2.png"
import productorIcon from "../../images/proccess3.png"
import ongIcon2 from "../../images/proccess5.png"


function Home() {

    const navigate = useNavigate()
    function goTo(route) {
      navigate(route);
    }

  return (
    <div>
        <Jumbotron tittle={"Carbono Zero"} 
        text={"Luchemos contra el Cambio Climático, midiendo, reduciendo y compensando"}
        btnText={"Comenzar"}
        background="backgroundJumbotron1"
        navigate={() => goTo("/contacto")}
        />

      <div className=" text-center">

          <div className="d-flex flex-row flex-wrap py-4 col-12">
              <h1 className="col-12 py-5 mb-5 tittleText fw-bold">¿QUÉ HACEMOS?</h1>
              
              <div className="military1Bg p-5 clickOver d-flex flex-column justify-content-center align-items-center col-12 col-md-4">
                <img src={industriaIcon} alt="industryIcon" />
                <h2 className='pt-5 text-white'>Medir</h2>
                <p className="text-white">la huella de Carbono(CO2) de tu negocio o institución.</p>
              </div>

              <div className="military2Bg p-5 clickOver d-flex flex-column justify-content-center align-items-center col-12 col-md-4">
                <img src={focoIcon} alt="focoIcon" />
                <h2 className='pt-5 text-white'>Reducir</h2>
                <p className="text-white">tus emisiones de Carbono(CO2) mediante acciones.</p>
              </div>

              <div className="military3Bg p-5 clickOver d-flex flex-column justify-content-center align-items-center col-12 col-md-4">
                <img src={arbolIcon} alt="arbolIcon" />
                <h2 className='pt-5 text-white'>Compensar</h2>
                <p className="text-white">el resto plantando árboles nativos Santiagueños.</p>
              </div>
          </div>


          <div className="py-5 px-5 d-flex flex-column justify-content-center align-items-center py-4">
            <h1 className="col-12 py-5 mb-5 tittleText fw-bold">BOSQUE COMUNITARIO VIRTUAL</h1>
            <p className="grey fs-4">Creemos que el desarrollo sostenible viene de la mano con todos los sectores de la sociedad, por eso artículamos entre empresas, ONGs, productores y ciudadanos para disminuir las emisiones de Carbono.</p>
          
            <div className='d-flex flex-row flex-wrap col-12 justify-content-center align-items-center'>
              <div className="clickOver1 col-11 col-md-5">
                  <img className="d-none d-md-block" src={empresaIcon} alt="empresaIcon" width="400px"/>
                  <img className="d-block d-md-none" src={empresaIcon} alt="empresaIcon" width="100%"/>
              </div>
              <div className="text-start col-11 col-md-7">
                <h1 className="military3">Empresas</h1>
                <p className="fs-4 grey">Disminuyen sus emisiones de Carbono (CO2) y aportes al Cambio Climático, obteniendo un perfil más verde y con responsabilidad social y ambiental.</p>
              </div>
            </div>

            <div className='d-flex flex-row flex-wrap col-12 justify-content-center align-items-center'>
              <span className='col-11 col-md-5 d-block d-md-none'>
                 <img src={productorIcon} alt="productorIcon"  width="100%"/>
              </span>
              <span className="col-11 col-md-7 text-end">
                <h1 className="military3">Productor</h1>
                <p className="fs-4 grey">Produce plantines de árboles nativos, que son comprados por las empresas como método de compensación de emisiones. Generando ganancias para ambos.</p>
              </span>
              <span className='col-11 col-md-5 clickOver1 d-none d-md-block'>
                 <img src={productorIcon} alt="productorIcon"  width="400px"/>
              </span>
            </div>

            <div className='d-flex flex-row flex-wrap col-12 justify-content-center align-items-center'>
              <span className='col-11 col-md-5 clickOver1'>
                 <img className="d-none d-md-block" src={ongIcon2} alt="ongIcon2"  width="400px"/>
                 <img className="d-block d-md-none" src={ongIcon2} alt="ongIcon2"  width="100%"/>
              </span>
              <span className="col-11 col-md-7 text-start">
                <h1 className="military2">ONG</h1>
                <p className="fs-4 grey">Recibe los plantines comprados, como donación de la empresa. Se encarga de intercambiarlos en "Eco-Canjes" por material para reciclar (botellas, carton, etc) que lleven las personas interesadas o a quienes tengan interés en plantar uno o varios árboles.</p>
              </span>
            </div>

            <div className='d-flex flex-row flex-wrap col-12  flex-wrap justify-content-center align-items-center'>
              <span className='d-md-none col-11 col-md-5'>
                 <img src={arboladoIcon} alt="arboladoIcon" width="100%"/>
              </span>
              <span className="col-11 col-md-7 text-end">
                <h1 className="military2">Sociedad</h1>
                <p className="fs-4 grey">Quienes reciben los plantines, pasarán a componer el "Bosque Comunitario Virtual". Donde se registrará  el lugar y uso del plantín (arbolado urbano, reforestación, plantaciones productivas etc).</p>
              </span>
              <span className='d-none d-md-block col-11 col-md-5 clickOver1'>
                 <img src={arboladoIcon} alt="arboladoIcon" width="400px"/>
              </span>
            </div>

          </div>



          <div className='d-flex flex-wrap justify-content-center align-items-center pt-5 mt-3'>
            <div className=''>
              <p className="fs-4 p-5 mb-5 col-12 text-white greenTwoBackground">
              Formando así un gran mapa en vivo de árboles que están creciendo, capturando Carbono y mitigando el Cambio climático en este mismo momento!
              </p>
            </div>

            <div className="d-flex flex-column col-8 my-5">
              <p className="fs-4 fw-bold">¿Quieres conocer nuestro bosque comunitario virtual y ver como Santiago del Estero se pinta de verde con nuestro proyecto?</p>
              <button onClick={() => goTo("/bosque-comunitario")} className="btn btn-lg btn-success fw-bold fs-3 regularText text-white">Ir al bosque comunitario virtual</button>
            </div>
          </div>




          <div className="py-5 my-5">

            <div className='px-5 mb-5'>
               <h1 className="col-12 pt-5  tittleText fw-bold">LAS ESPECIES DE NUESTRO MONTE</h1>
                <p className="grey fs-4">las especies de árboles nativas del bosque de Chaco Seco Santiagueño, son una herramienta increible que nos brinda la naturaleza para combatir el cambio climático.</p>
            </div>

            <h1 className="mt-5 military2">¿Cuanto pueden ayudar?</h1>
            <p className="grey fs-4"> La cantidad de Carbono (principal causante del cambio climatico) que pueden capturar las especies, varia entre ellas. Un ejemplar de mas de 7 años suele capturar...</p>

            <div className="col-12 mb-5 py-5 d-flex flex-row flex-wrap justify-content-center align-items-center">
                <span className="algarroboBackground py-5 px-3  col-12 col-md-4 clickOver1">
                  <h1 className='text-white'>Algarrobo</h1>
                  <h1 className='text-white'>=</h1>
                  <h1 className='text-white'>163 kg CO2</h1>

                </span>
                <span className="quebrachoBackground py-5 px-3  col-12 col-md-4 clickOver1">
                  <h1 className='text-white'>Quebracho</h1>
                  <h1 className='text-white'>=</h1>
                  <h1 className='text-white'>3 kg CO2</h1>
                </span>
                <span className="mistolBackground py-5 px-3  col-12 col-md-4 clickOver1">
                  <h1 className='text-white'>Mistol</h1>
                  <h1 className='text-white'>=</h1>
                  <h1 className='text-white'>62 kg CO2</h1>
                </span>
            </div>

            <button onClick={() => goTo("/bosque-comunitario")}  className="mx-3 mb-5 btn btn-lg btn-success fw-bold fs-3 regularText text-white">Conoce que otras especies plantamos</button>

          </div>
      </div>

    </div>
  )
}

export default Home